import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { Tenant } from '@src/api/tenant/auth/tenantAuthStatusApiClient';

export type TenantUpdateRequest = {
  tenant: {
    name: string;
    name_kana: string;
    family_name: string;
    first_name: string;
    family_name_kana: string;
    first_name_kana: string;
    admin_email: string;
    phone_number: string;
  };
};

export type TenantUpdateResponse = unknown;

export type TenantUpdateErrorResponse = {
  tenant: {
    name: string[];
    name_kana: string[];
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    admin_email: string[];
    phone_number: string[];
  };
};

export type TenantShowResponse = {
  tenant: Tenant;
};

export const tenantApiClient = {
  show: async (): Promise<ApiResult<TenantShowResponse>> => {
    return await axiosClient.get('/tenant/tenants');
  },
  update: async (
    id: number,
    params: TenantUpdateRequest,
  ): Promise<ApiResult<TenantUpdateResponse, TenantUpdateErrorResponse>> => {
    return await axiosClient.put(`/tenant/tenants/${id}`, params);
  },
};
